const routes = [
	{
		name: 'root',
		path: '/',
		redirect: 'login',
        meta: {
            requiresAuth: false,
            title: null
        }
	},
	{
		name: 'graph',
		path: '/graph',
		component: graphPage,
		meta: {
            requiresAuth: true,
            title: null
        }
	},
    {
    	name: 'login',
        path: '/login',
        component: loginPage,
		meta: {
        	requiresAuth : false,
			title: null
		}
    }
];

const router = new VueRouter({
	// mode: "history",
	routes: routes,
	data:{
		user: 'Bruger',
	},
});

router.beforeEach((to, from, next) => {
	// Set document title to default
	// document.title = t(to.meta.title || 'title.default');
	// document.title = 'Statistik';

	// allow dashboard show if dashkey has been validated

	// next();

	// console.log(to);
	//

	if(to.meta.requiresAuth === undefined){
		next('/login');
	}
	else if(to.meta.requiresAuth === true){
		session.autoLogin(to, from, next);
	}else{
		next();
	}
});
